
export default {
  name: "UnitPromotionList",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    showAddMoreBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inViewLen: 3,
      isShowAll: false
    }
  },
  computed: {
    itemsLen() {
      return this.items.length
    },
    isShowViewBtn() {
      return this.itemsLen > this.inViewLen
    },
    displayItems() {
      if (!this.isShowAll && this.isShowViewBtn) {
        return this.items.slice(0, this.inViewLen)
      }
      return this.items
    }
  },
  methods: {
    addMore(item) {
      console.log("addMore===>", item)
      this.$emit("addMore", item)
    },
    toggleViewBtnClick() {
      this.isShowAll = !this.isShowAll
    }
  }
}
